var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"va-count-badge"},[_vm._t("default"),(_vm.displayNumber !== '0')?_c('span',{staticClass:"va-count-badge__round",style:(_vm.computedStyle)},[_vm._v("\n    "+_vm._s(_vm.displayNumber)+"\n  ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }